import { EquipSlot, WeaponData } from '@common/components/components';

/**
 * Item definitions for spawning items via dialogue, loot, etc.
 * Items are identified by a string itemId used in Ink scripts.
 */
export interface ItemDefinition {
  displayName: string;
  spritesheetId: string;
  frameIndex?: number;
  /** Maximum stack size. Defaults to 1 (non-stackable). */
  maxStack?: number;
  /**
   * Non-hand slots where this item can be equipped.
   * Hand slots (mainHand, offHand) accept any item regardless of this field.
   * Only needed for armor, rings, etc. that go in specific body slots.
   */
  equipSlots?: EquipSlot[];
  /** Combat stats for weapons. */
  weaponStats?: WeaponData;
}

/**
 * Registry of all item types in the game.
 * These IDs are used in Ink scripts when calling giveNewItem("itemId").
 */
export const ItemRegistry: Record<string, ItemDefinition> = {
  wood: {
    displayName: 'Wood',
    spritesheetId: 'wood',
    maxStack: 50,
    // No equipSlots - can be held in hands like any item
  },
  sword: {
    displayName: 'Sword',
    spritesheetId: 'sword',
    // No equipSlots - swords go in hands, which accept any item
    weaponStats: {
      damage: 1,
      range: 32, // 2 tiles
      arc: 90, // Wide swing
      cooldownMs: 500,
      knockbackForce: 100,
      swingPattern: 'arc',
      hitboxCount: 4,
      bladeWidth: 10,
    },
  },
  // Example: helmet would have equipSlots: ['head'] so it can be worn
};
